// modules/estrategias/migrante/components/MapaMigrante.js
import { useEffect, useRef } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const puntoAzul = (destacado = false) => L.divIcon({
  className: "",
  html: `<div style="
    width:${destacado ? 20 : 14}px;height:${destacado ? 20 : 14}px;border-radius:50%;
    background:${destacado ? "#dc3545" : "#1a6fe0"};
    border:3px solid #fff;box-shadow:0 0 4px rgba(0,0,0,.45);
  "></div>`,
  iconSize: [destacado ? 20 : 14, destacado ? 20 : 14],
  iconAnchor: [destacado ? 10 : 7, destacado ? 10 : 7],
  popupAnchor: [0, destacado ? -10 : -7],
});

const CENTRO_DEFECTO = [-4.2153, -69.9406]; // Leticia, Amazonas

function Marcador({ persona, destacado }) {
  const ref = useRef(null);
  useEffect(() => { if (destacado && ref.current) ref.current.openPopup(); }, [destacado]);
  return (
    <Marker ref={ref} position={[parseFloat(persona.latitud), parseFloat(persona.longitud)]} icon={puntoAzul(destacado)}>
      <Popup>
        <div style={{ fontSize: "0.85rem" }}>
          <strong>{persona.primer_nombre} {persona.primer_apellido}</strong><br />
          Documento: {persona.documento}<br />
          {persona.municipio && <>Territorio: {persona.municipio}<br /></>}
          {persona.precision_gps && <span className="text-muted">± {persona.precision_gps} m de precisión</span>}
        </div>
      </Popup>
    </Marker>
  );
}

export default function MapaMigrante({ registros, foco }) {
  const conUbicacion = registros.filter(p => p.latitud && p.longitud);
  const focoConUbicacion = foco?.latitud && foco?.longitud ? foco : null;

  const centro = focoConUbicacion
    ? [parseFloat(focoConUbicacion.latitud), parseFloat(focoConUbicacion.longitud)]
    : conUbicacion.length ? [parseFloat(conUbicacion[0].latitud), parseFloat(conUbicacion[0].longitud)]
    : CENTRO_DEFECTO;
  const zoom = focoConUbicacion ? 15 : conUbicacion.length > 1 ? 9 : 13;

  return (
    <div style={{ borderRadius: 14, overflow: "hidden", border: "1px solid #e5e7eb" }}>
      {conUbicacion.length === 0 ? (
        <div className="text-center text-muted py-5">
          Ningún registro (de los que ves en esta lista) tiene ubicación GPS capturada todavía.
        </div>
      ) : (
        <MapContainer key={centro.join(",")} center={centro} zoom={zoom} style={{ height: 480, width: "100%" }}>
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          {conUbicacion.map(p => (
            <Marcador key={p.id} persona={p} destacado={focoConUbicacion?.id === p.id} />
          ))}
        </MapContainer>
      )}
    </div>
  );
}
